/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetRadialIcon16Light = forwardRef('TargetRadialIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 6.004a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-1 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 8.004a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4.5-3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.004a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z" })));
});
